import type { CarouselProps } from '@nuxt/ui'

const fullWidthCarousel: NonNullable<CarouselProps['ui']> = {
  item: 'basis-full',
}

const fullCarousel: NonNullable<CarouselProps['ui']> = {
  root: 'h-full',
  viewport: 'h-full',
  container: 'h-full',
  item: 'basis-full h-full',
}

const fullCarouselWithArrows: NonNullable<CarouselProps['ui']> = {
  root: 'h-full',
  viewport: 'h-full',
  container: 'h-full',
  item: 'basis-full h-full',
  arrows: 'hidden md:flex',
}

const fullCarouselWithAlwaysArrows: NonNullable<CarouselProps['ui']> = {
  root: 'h-full',
  viewport: 'h-full',
  container: 'h-full',
  item: 'basis-full h-full',
  arrows: 'flex',
}

const cottageCarousel: NonNullable<CarouselProps['ui']> = {
  container:
    'relative w-full flex snap-x snap-mandatory scroll-smooth py-1 ms-auto lg:grid lg:grid-cols-12 lg:gap-x-4 lg:px-0 lg:overflow-x-visible',
  item: 'basis-auto ps-2 pe-2 first:ps-4 last:pe-4 lg:block lg:col-span-3 lg:last:pe-0 lg:ps-0 lg:pe-0 lg:first:ps-0',
}

const imagesCarousel: NonNullable<CarouselProps['ui']> = {
  container:
    'relative w-full flex snap-x snap-mandatory scroll-smooth py-1 ms-auto lg:grid lg:grid-cols-10 lg:gap-x-4 lg:px-0 lg:overflow-x-visible no-scrollbar',
  item: 'basis-auto ps-2 pe-2 first:ps-4 last:pe-4 lg:block lg:col-span-2 lg:last:pe-0 lg:ps-0 lg:pe-0 lg:first:ps-0',
}
export {
  cottageCarousel,
  fullWidthCarousel,
  fullCarousel,
  imagesCarousel,
  fullCarouselWithArrows,
  fullCarouselWithAlwaysArrows,
}
